module.exports = __webpack_public_path__ + "media/react/pages/lessons/show/activities/assets/video_clip_icon-db1dbf772217501a834061826c3c8ed7.svg";